import {
  GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST,
  GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS,
  GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE,
  GET_TRANSFER_LINE_DOC_BY_ID_REQUEST,
  GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS,
  GET_TRANSFER_LINE_DOC_BY_ID_FAILURE,
  GET_UNMASKING_APPROVAL_REQUEST,
  GET_UNMASKING_APPROVAL_SUCCESS,
  GET_UNMASKING_APPROVAL_FAILURE,
  UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE,
  UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST,
  UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS
} from './actionTypes';
import {
  IGetTransferLineOrderApprovalRequest, IGetTransferLineOrderApprovalSuccess, IGetTransferLineOrderApprovalFailure, IGetTransferLineDocByIdRequest, IGetTransferLineDocByIdSuccess, IGetTransferLineDocByIdFailure, IGetUnmaskingApprovalFailure, IGetUnmaskingApprovalRequest, IGetUnmaskingApprovalSuccess,
  IUpdateUnmaskingApprovalStatusRequest,
  IUpdateUnmaskingApprovalStatusSuccess,
  IUpdateUnmaskingApprovalStatusFailure
} from './models/types';

export const getTransferLineOrderApproval = {
  request: (reqData): IGetTransferLineOrderApprovalRequest => ({ type: GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST, reqData }),
  success: (data): IGetTransferLineOrderApprovalSuccess => ({ type: GET_TRANSFER_LINE_ORDER_APPROVAL_SUCCESS, data }),
  failure: (error): IGetTransferLineOrderApprovalFailure => ({ type: GET_TRANSFER_LINE_ORDER_APPROVAL_FAILURE, error })
};

export const getTransferLineDocById = {
  request: (reqData): IGetTransferLineDocByIdRequest => ({ type: GET_TRANSFER_LINE_DOC_BY_ID_REQUEST, reqData }),
  success: (data): IGetTransferLineDocByIdSuccess => ({ type: GET_TRANSFER_LINE_DOC_BY_ID_SUCCESS, data }),
  failure: (error): IGetTransferLineDocByIdFailure => ({ type: GET_TRANSFER_LINE_DOC_BY_ID_FAILURE, error })
};

export const getUnmaskingApproval = {
  request: (reqData): IGetUnmaskingApprovalRequest => ({ type: GET_UNMASKING_APPROVAL_REQUEST, reqData }),
  success: (data): IGetUnmaskingApprovalSuccess => ({ type: GET_UNMASKING_APPROVAL_SUCCESS, data }),
  failure: (error): IGetUnmaskingApprovalFailure => ({ type: GET_UNMASKING_APPROVAL_FAILURE, error })
};

export const updateUnmaskingApprovalStatus = {
  request: (reqData): IUpdateUnmaskingApprovalStatusRequest => ({ type: UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST, reqData }),
  success: (data): IUpdateUnmaskingApprovalStatusSuccess => ({ type: UPDATE_UNMASKING_APPROVAL_STATUS_SUCCESS, data }),
  failure: (error): IUpdateUnmaskingApprovalStatusFailure => ({ type: UPDATE_UNMASKING_APPROVAL_STATUS_FAILURE, error })
};
